import React from 'react'

import firstImage from '../../../assets/img/mulher.png'

const Demand: React.FC = () => {
  return (
    <div className="row partner-demands margin-top-16">
      <div className="list">
        <div className="list-header">

          <div style={{ width: 50 }}/>
          <div className="">Parceiro</div>
          <div className="">Pagamento</div>
          <div className="">Status</div>
          <div className="">Avaliação</div>
          <div className="">Data do Pedido</div>
          <div style={{ width: 50 }}/>
        </div>

        <div className="list-row">

          <img
            src={firstImage}alt="Parceiro"
            style={{ height: 48, width: 48 }}
          />
          <div className="">Aonix Food</div>
          <div className="">Cartão de Crédito</div>
          <div className="">Pedido Entregue</div>
          <div className="">
            <button
              className="justify-start center-center stars" style={{ backgroundColor: 'transparent', width: '100%' }}>
              <i className="far fa-1x fa-star padding-8"></i>
              <i className="far fa-1x fa-star padding-8"></i>
              <i className="far fa-1x fa-star padding-8"></i>
              <i className="far fa-1x fa-star padding-8"></i>
              <i className="far fa-1x fa-star padding-8"></i>
            </button>
          </div>
          <div className="">30/03/2020 às 21:02 1:35</div>

          <span
            style={{
              height: 40,
              width: 40,
              backgroundColor: '#00000012',
              borderRadius: '50%',
              justifyContent: 'center',
              alignItems: 'center',
              display: 'flex'
            }}>
            <i className="far fa-1x fa-folder-open" /></span>
        </div>
      </div>

    </div>
  )
}

export default Demand
